import React, { useEffect } from 'react';

import Heading from '../components/Headers/Heading';
import Art from '../components/Misc/Art';
import illustration from '../assets/images/art_1.png';
import CareersContent from '../components/TextContent/CareersContent';
import CareerSection from '../components/AboutComponents/CareerSection';
import StudentCareerSection from '../components/AboutComponents/StudentCareerSection';
import Seo from '../components/Misc/Seo';

import careersHeaderImage from '../assets/images/careers-header.jpg';
import careersImage1 from '../assets/images/careers-1.jpg';
import careersImage2 from '../assets/images/careers-2.jpg';
import careersImage3 from '../assets/images/careers-3.jpg';
import careersImage4 from '../assets/images/careers-4.jpg';

function Careers() {
    const canonical = 'https://studio.norcat.org/Careers';
    const title = 'Careers at Studio NORCAT | A Studio driven by experiences that matter.';
    const description =
        'Explore career opportunities at Studio NORCAT and join a multidisciplinary team building meaningful technology for learning, training, and workforce development.';

    useEffect(() => {
        document.body.classList.add('careers-page-view');

        return () => {
            document.body.classList.remove('careers-page-view');
        };
    }, []);

    return (
        <div className="careers-page">
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${careersHeaderImage}`}
                ogImageAlt="Studio NORCAT team and studio environment on the Careers page"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${careersHeaderImage}`}
                twitterImageAlt="Studio NORCAT team and studio environment on the Careers page"
            />
            <div className="page-header position-relative">
                <Heading
                    heading={<h1>Careers</h1>}
                    headingClass="heading-very-large dark-1"
                    paragraph="Work with a multidisciplinary team building meaningful technology for learning and training."
                    paragraphClass="dark-2"
                    WrapperComponent={(props) => {
                        return (
                            <div className="page-header-top">
                                <div className="container">
                                    {props.children}
                                </div>
                            </div>
                        )
                    }}
                />

                <div className="page-header-bottom">
                    <div className="single-image">
                        <img src={careersHeaderImage} alt="Studio NORCAT team member demonstrates a VR program" />
                    </div>
                    <Art art={illustration} type="1" />
                </div>

            </div>

            <CareersContent />
            <br /><br />
                <div className="single-image-wrapper">
                <div className="single-image">
                    <img src={careersImage3} alt="A Studio NORCAT team member performs in the Motion Capture Volume" />
                </div>
                <div className="single-image">
                    <img src={careersImage4} alt="A Studio NORCAT artist creates assets for our VR programs" />
                </div>
            </div><br /><br />
            <br /><br /><br /><br /><br />  
            <CareerSection />
            <StudentCareerSection />

            <br /><br />  
            <div className="single-image-wrapper">
                <div className="single-image">
                    <img src={careersImage1} alt="Trainers view a demonstration of Studio NORCAT's VR programs" />
                </div>
                <div className="single-image">
                    <img src={careersImage2} alt="A trainer tries out a VR training program at Studio NORCAT" />
                </div>
            </div><br /><br />

            {/*
            <div className="page-header-bottom">
                <div className="single-image">
                    <img src={careersFooterImage} alt="careers-footer" />
                </div>
                <Art art={illustration} type="1" />
            </div>
            */}
        </div>
    );
}

export default Careers;
